import { number, object } from 'yup';
import i18n from 'config/i18n';

const numberROIRequired = i18n.t('analytics:roi_currency_input_required');

const ROICurrencyInputSchema = () => {
  return object().shape({
    reach_twitter: number().noWhitespace().typeError(numberROIRequired),
    reach_linkedin: number().noWhitespace().typeError(numberROIRequired),
    clicks_twitter: number().noWhitespace().typeError(numberROIRequired),
    clicks_linkedin: number().noWhitespace().typeError(numberROIRequired),
    clicks_facebook: number().noWhitespace().typeError(numberROIRequired),
    engagements_twitter: number().noWhitespace().typeError(numberROIRequired),
    engagements_linkedin: number().noWhitespace().typeError(numberROIRequired),
    engagements_facebook: number().noWhitespace().typeError(numberROIRequired),
  });
};

export { ROICurrencyInputSchema };
